export function isTerminalUploadStatus(status) {
    return [
        "available",
        "staged",
        "abandoned",
        "rejected",
        "failed",
    ].includes(String(status || ""));
}

export function formatUploadStatusLabel(status) {
    const normalizedStatus = String(status || "");

    if (normalizedStatus === "staged") {
        return "Ready to post";
    }

    if (normalizedStatus === "") {
        return "";
    }

    return normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1);
}

export function normalizeUploadStatusUrl(statusUrl) {
    if (!statusUrl) {
        return "";
    }

    try {
        const baseUrl = typeof window !== "undefined"
            ? window.location.origin
            : "http://localhost";
        const url = new URL(String(statusUrl), baseUrl);
        const fileIdKeys = [];

        for (const key of url.searchParams.keys()) {
            if (key === "file_ids" || key.startsWith("file_ids[")) {
                fileIdKeys.push(key);
            }
        }

        fileIdKeys.forEach((key) => {
            url.searchParams.delete(key);
        });

        return url.toString();
    } catch (_error) {
        return String(statusUrl);
    }
}

export function groupPendingUploadPollTargets(files) {
    return files.reduce((groups, file) => {
        const fileId = Number.parseInt(String(file?.fileId || "0"), 10);
        const statusUrl = normalizeUploadStatusUrl(file?.statusUrl);

        if (fileId <= 0 || statusUrl === "" || isTerminalUploadStatus(file?.status)) {
            return groups;
        }

        if (!groups.has(statusUrl)) {
            groups.set(statusUrl, []);
        }

        groups.get(statusUrl).push(fileId);

        return groups;
    }, new Map());
}
